import { BaseGmapPanel, BaseGmapPanelProps, BaseGmapPanelState } from '../base/BaseGmapPanel';
import { getAjaxhelper, isNull, getFromCacheOrRequestHotelCategoryCatalog, getOnlyFromCacheHotelCategoryCatalog } from '../utils/index';
import { getHotelSlug } from '../core/index';
import { HotelBedData } from '../shared/HotelBedData';
export interface GmapWithBasePanelProps extends BaseGmapPanelProps { }
export interface GmapWithBasePanelState extends BaseGmapPanelState { }
export class GmapWithBasePanel extends BaseGmapPanel<GmapWithBasePanelProps, GmapWithBasePanelState> {
    constructor(props: GmapWithBasePanelProps) {
        super(props);
        this.state = {
            leftSideClassName: 'leftsidegmap',
            leftsidegmapmenu: 'leftsidegmapmenu',
            topSearchMap: "topsearch-map",
            dataHotels: [], dataHotelsFiltered: [],
            requesting: true,
            indexedCategoryData: getOnlyFromCacheHotelCategoryCatalog(),
            version: 0,
            selectCreatable: false,
            selectValue: {},
            backspaceRemoves: true,
            minPrice: 1000000000,
            maxPrice: 0,
            minRate: 1000000000,
            maxRate: 0,
            versi: 0,
            lastSelectedCode: 0,
            wishlistAnimeClass: 'hide',
            initialFilter: null,
            indexHotel: {}
        };
    }

    onMapRendered(map: google.maps.Map) {
        let page = 0;
        this.getAvailabilityHotel(page, map);
    }

    getAvailabilityHotel: (page: number, map: google.maps.Map) => any = (page: number, map: google.maps.Map) => {
        let sessionResponKey = this.props.responKey;
        let responKey = '';
        let pageSize = 100;
        if (!isNull(sessionResponKey)) {
            responKey = sessionResponKey;
        }
        let ids: number[] = [];
        if (this.props.idHotels) {
            ids = [this.props.idHotels];
        } 
        // if (ids.length !== 0) {
        getAjaxhelper().post('/dynamics/hb-api/hotels-availability-for-map', {
            "reqKey": responKey,
            "rowCount": pageSize,
            "page": page,
            currencyCode: isNull(this.props.currency) ? 'AUD' : this.props.currency,
            hotelCodes: ids
            // externalFilter: this.state.externalFilter
        }).then((d: any) => {
            let filter = d.reqDetail;
            let datas = d.rows;
            let min = this.state.minRate;
            let max = this.state.maxRate;
            const indexHotel: { [id: number]: HotelBedData.Hotel } = {};
            try {
                for (let a of datas) {
                    if (a.minRate < min) {
                        min = a.minRate;
                    }
                    if (a.maxRate > max) {
                        max = a.maxRate;
                    }
                    indexHotel[a.code] = a;
                }
            } catch (err) {
                console.error('debug hari inin', err);
            }

            this.setStateHelper(
                st => {
                    try {
                        // let idxHotelTmp = 
                        st.dataHotels = [...st.dataHotels, ...datas];
                        st.dataHotelsFiltered = [...st.dataHotelsFiltered, ...datas];
                        st.requesting = true;
                        st.minPrice = min;
                        st.minRate = min;
                        st.maxPrice = max;
                        st.maxRate = max;
                        st.versi++;
                        st.initialFilter = filter;
                        st.indexHotel = Object.assign(indexHotel, st.indexHotel);
                    } catch (err) {
                        console.error('debug hari ini dalam setStateHelper', err);
                    }
                },
                () => {
                    try {
                        if (d.count > ((page + 1) * pageSize)) {
                            let p = page + 1;
                            this.getAvailabilityHotel(p, map);
                        } else {
                            this.setStateHelper(
                                st => {
                                    st.requesting = false;
                                },
                                () => {
                                    var dataMapHotel = [];

                                    for (let data of this.state.dataHotels) {
                                        dataMapHotel.push(
                                            {
                                                cordinat: { lat: data.latitude! / 1, lng: data.longitude! / 1 },
                                                hotelName: data.name,
                                                hotelDesc: data.description,
                                                hotelImages: `${data.image}`,
                                                slug: getHotelSlug(data.name!, data.code!),
                                                tripAdvisorRatingImage: data.tripAdvisorRatingImage,
                                                minRate: data.minRate, currency: data.currency,
                                                alldata: data,
                                                star: data.star
                                            }
                                        );
                                    }
                                    this.gMaker(dataMapHotel, map);
                                }
                            );
                        }
                    } catch (err) {
                        console.error('debug hari ini after setStateHelper', err);
                    }
                }
            );
        }).catch((exc) => { console.error('error: ', exc); });
        // }  
    }

    componentDidMount() {
        this.registerGmapScript();

        if (!this.state.indexedCategoryData) {
            getFromCacheOrRequestHotelCategoryCatalog()
                .then(d1 => {
                    this.setStateHelper(st => {
                        st.indexedCategoryData = d1;
                        st.version += 1;
                    });
                }).catch(exc => {
                    console.error(`[HotelSearchResultMainPanelWithBulkData#componentDidMount] gagal membaca data hotel category. error: `, exc);
                });
        }
    }

    generateMapOption(): google.maps.MapOptions {
        /*
        let styles = [
            {
                featureType: 'poi.business',
                stylers: [{ visibility: 'off' }]
            },
            {
                featureType: 'transit',
                elementType: 'labels.icon',
                stylers: [{ visibility: 'off' }]
            }
        ];
*/
        return {
            center: this.props.defMapCenter,
            gestureHandling: 'cooperative',
            zoom: this.props.mapZoom,
            styles: [
                {
                    featureType: 'poi.business',
                    stylers: [{ visibility: 'off' }]
                },
                {
                    featureType: 'transit',
                    elementType: 'labels.icon',
                    stylers: [{ visibility: 'off' }]
                }]
        };
    }

}


// WEBPACK FOOTER //
// ./src/core/GmapWithBasePanel.tsx